module.exports = __webpack_public_path__ + "static/mobile-f9761ddc6e58e9422317a18c230e6ffd.svg";